<script lang="ts">
    import { apiBaseURL } from "../../config"

    export let collectionName: string = "content"
    export let entryId: string = null
    export let file: File = null
    export let alt: string = ""
    export let cssClass: string = ""
    export let imageFilter: string = "l"
</script>

{#if collectionName && entryId && file}
    {#if file?.src?.includes(";base64,")}
        <img src="{file.src}" alt="{alt ? alt + ' - ' : ''}{file.path}" class="{cssClass}" on:click on:keyup />
    {:else}
        <img
            src="{`${apiBaseURL}${collectionName}/${entryId}/${file.src}?filter=${imageFilter}`}"
            alt="{alt ? alt : file.path}"
            class="{cssClass}"
            on:click
            on:keyup
        />
    {/if}
{/if}

<!-- <picture>

    Example 1
    
    <picture>
        <source srcset="/media/cc0-images/surfer-240-200.jpg"
                media="(orientation: portrait)">
        <img src="/media/cc0-images/painted-hand-298-332.jpg" alt="">
    </picture>

    Example 2

    <source
        media="(min-width: 1400px)"
        data-srcset="https://www.framos-holding.de/wp-content/uploads/2020/09/fresh-IT-3.jpg"
        srcset="https://www.framos-holding.de/wp-content/uploads/2020/09/fresh-IT-3.jpg"
    />
    <source
        media="(min-width: 768px)"
        data-srcset="https://www.framos-holding.de/wp-content/uploads/2020/09/fresh-IT-3.jpg"
        srcset="https://www.framos-holding.de/wp-content/uploads/2020/09/fresh-IT-3.jpg"
    />
    <source
        media="(min-width: 400px)"
        data-srcset="https://www.framos-holding.de/wp-content/uploads/2020/09/fresh-IT-3.jpg"
        srcset="https://www.framos-holding.de/wp-content/uploads/2020/09/fresh-IT-3.jpg"
    />
    <source
        data-srcset="https://www.framos-holding.de/wp-content/uploads/2020/09/fresh-IT-3-400x267.jpg"
        srcset="https://www.framos-holding.de/wp-content/uploads/2020/09/fresh-IT-3-400x267.jpg"
    />
    <img
        data-src="https://www.framos-holding.de/wp-content/uploads/2020/09/fresh-IT-3-400x267.jpg"
        alt="fresh IT GmbH"
        src="https://www.framos-holding.de/wp-content/uploads/2020/09/fresh-IT-3-400x267.jpg"
    />
</picture> -->
